import { CopyOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Drawer,
  Form,
  Image,
  Input,
  message,
  Popconfirm,
  Progress,
  Row,
  Select,
  Steps,
  Tabs,
} from "antd";
import Container from "components/container";
import { FC, Fragment, useEffect, useState } from "react";

import { LogoutOutlined } from "@ant-design/icons";
import { AUTH_TEACHER } from "api/services/auth/auth.api.routes";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { StatusCode, UserRoles } from "common/enums";
import UploadAvatar from "components/uploadAvatar/UploadAvatar";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import fr from "react-phone-input-2/lang/fr.json";
import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";
import { closeProfileDrawer, logout, updateUser } from "store/auth/authSlice";
import { clearRoom } from "store/chat/roomSlice";
import { clearRooms } from "store/chat/roomsSlice";
import BackBlack from "../../assets/images/app/backBlack.svg";

//!STYLES
import CertificationBadge from "components/certificationBadge";
import AppButton from "components/libs/button";
import UpdatePasswordDrawer from "components/updatePasswordDrawer";
import React from "react";
import ProfileTeacher from "screens/teacher/profileTeacher";
import { setCorrectingLevel } from "store/app/appSlice";
import s from "./assets/drawerProfile.module.css";
import ParentOrganismUpdateProfile from "./parentOrganism";
import UpdateProfileStepTwo from "./stepTwo";
import StudentUpdateProfile from "./student";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import AvatarModal from "components/avatarsModal";
import TimeZoneList from "screens/teacher/components/TimeZoneList";
import CheckIcon from "../../assets/images/app/check.svg";
import EditButton from "../../assets/images/app/edit_avatar_button.svg";

import WelcomeModal from "components/appModal/welcomeModal";
import WhatsappAlertModal from "components/appModal/whatsappAlertModal";
import PhoneModificationModal from "components/OTP/phoneModificationModal";
import PhoneOTPModal from "components/OTP/phoneVerification";
import { appAuth, RecaptchaVerifier } from "../../config/firebase.config";

declare global {
  interface Window {
    recaptchaVerifier: any;
  }
}

const { Panel } = Collapse;
const { TabPane } = Tabs;

const { Step } = Steps;
const { Option } = Select;
const getBase64 = (img: any, callback: any) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const AppDrawer: FC = () => {
  //!HOOKS
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [formInfos] = Form.useForm();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { isCorrectingLevel, newPasswordRequired } = useSelector((state) => state.app);

  const {
    profileDrawerOpen,
    isLoggedIn,
    user,
    isLoggingOut,
    isUpdating,
    updateErrors,
  } = useSelector((state) => state.auth);
  const levels = useSelector((state) => state.levels);
  const { socket } = useSelector((state) => state.appChat);

  //STATES
  const [isPhoneVerified, setIsPhoneVerified] = useState<boolean>(false);
  const [isEmailVerified, setIsEmailVerified] = useState<boolean>(false);
  const [isUpdatingData, setIsUpdatingData] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<string>("0");
  const [phoneState, setPhoneState] = useState<any>("");
  const [tempTopic, setTempTopic] = useState<any>([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState<string>("");

  const [userPhoneNumber, setUserPhoneNumber] = useState<string>("");
  const [openPhoneVerification, setOpenPhoneVerification] = useState<boolean>(false);
  const [openPhoneModification, setOpenPhoneModification] = useState<boolean>(false);
  const [confirmationResult, setConfirmationResult] = useState<any>(null);

  const [isWelcomeModalVisible, setIsWelcomeModalVisible] = useState<boolean>(false);
  const [isWhatsappModalVisible, setIsWhatsappModalVisible] = useState<boolean>(false);

  //!FUNCTIONS
  const closeDrawer = () => {
    if (user?.roles.includes(UserRoles?.ORGANISME)) {
      setCurrentStep("0");
      dispatch(setCorrectingLevel(false));
      dispatch(closeProfileDrawer());
      setSelectedAvatar("");
    }
    else {
      if (user?.whatsappEnabled) {
        setCurrentStep("0");
        dispatch(setCorrectingLevel(false));
        dispatch(closeProfileDrawer());
        setSelectedAvatar("");
      }
      else {
        setIsWhatsappModalVisible(true);
      }
    }
  };

  const closeWhatsappDrawer = () => {
    setIsWhatsappModalVisible(false);
    setCurrentStep("0");
    dispatch(setCorrectingLevel(false));
    dispatch(closeProfileDrawer());
    setSelectedAvatar("");
  };

  const clearCookies = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/");
    });
  };

  const disconnect = async () => {
    await socket.emit("unsubscribe", user?._id);
    socket?.disconnect();
    closeDrawer();
    dispatch(clearRoom());
    dispatch(clearRooms());
    dispatch(logout());
    clearCookies();
    localStorage.clear();
    sessionStorage.clear();
  };

  const deleteAccount = async () => {
    try {
      const response = await AUTH_SERVICES.deleteAccount(user?._id);
      if (response?.statusCode === StatusCode.OK) {
        disconnect();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleVerify = (otp: string) => {
    // Call Firebase confirm() or your backend verification
    verifyOTP(otp);
  };

  // Setup invisible reCAPTCHA
  const setUpRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        { size: "invisible" },
        appAuth
      );
    }
  };

  // Step 1: Send OTP
  const sendOtp = async (phoneNumber: string) => {
    try {
      const response = await AUTH_SERVICES.requestPhoneOTP(phoneNumber);
      if (response?.statusCode === StatusCode.CREATED) {
        setOpenPhoneVerification(true);
        setUserPhoneNumber(phoneNumber);
        setIsLoading(false);
        message.success(`Nous avons envoyé un code par SMS au ${phoneNumber}`);
      }
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  // Step 2: Verify OTP
  const verifyOTP = async (otp: string) => {
    try {
      setIsLoading(true);
      const response = await AUTH_SERVICES.verifyPhoneOTP(userPhoneNumber, otp);
      if (response?.statusCode === StatusCode.CREATED) {
        message.success("Code vérifié avec succès !");
        setOpenPhoneVerification(false);
        setIsUpdatingData(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      message.error("Code invalide !");
      setIsLoading(false);
    }
  };

  const updateUserInfos = async (values: any) => {

    setIsUpdatingData(true);
    setUserPhoneNumber("+" + values?.phone);

    const finalData = {
      email: values?.email,
      phone: values?.phone || "",
      firstname: values?.firstname,
      lastname: values?.lastname,
      pays: values?.pays || "",
      educSystem: values?.educSystem || "",
      etablissement: values?.etablissement || "",
      levelId: user?.roles.includes("student") ? values?.levelId ? values?.levelId : user?.levelId : "",
      whatsappEnabled: values?.whatsappEnabled,
      fuseauHorraire: values?.fuseauHorraire,
    };

    const finalStudentData = {
      email: values?.email,
      phone: values?.phone || "",
      firstname: values?.firstname,
      lastname: values?.lastname,
      pays: values?.pays || "",
      educSystem: values?.educSystem || "",
      etablissement: values?.etablissement || "",
      levelId: user?.roles.includes("student") ? values?.levelId ? values?.levelId : user?.levelId : "",
      whatsappEnabled: values?.whatsappEnabled,
      fuseauHorraire: values?.fuseauHorraire,
      profile: selectedAvatar,
    };

    try {
      const response = user?.roles.includes("teacher")
        ? await AUTH_SERVICES.updateTeacher(user?._id, {
          ...finalData,
        })
        : user?.roles.includes("student") ? await AUTH_SERVICES.updateStudent(user?._id, {
          ...finalStudentData,
        }) : await AUTH_SERVICES.updateParentOrganisme(user?._id, {
          ...finalData,
        });
      if (response?.statusCode === StatusCode.OK) {

        message.success({
          content: "Modifications effectuées !",
        });

        dispatch(
          updateUser(user?.roles.includes("student") ? {
            ...user,
            email: values?.email,
            phone: values?.phone || "",
            firstname: values?.firstname,
            lastname: values?.lastname,
            pays: values?.pays || "",
            educSystem: values?.educSystem || "",
            etablissement: values?.etablissement || "",
            levelId: values?.levelId ? values?.levelId : user?.levelId,
            whatsappEnabled: values?.whatsappEnabled,
            fuseauHorraire: values?.fuseauHorraire ? values?.fuseauHorraire : user?.fuseauHorraire,
            profile: selectedAvatar,
          } : {
            ...user,
            email: values?.email,
            phone: values?.phone || "",
            firstname: values?.firstname,
            lastname: values?.lastname,
            pays: values?.pays || "",
            educSystem: values?.educSystem || "",
            etablissement: values?.etablissement || "",
            levelId: "",
            whatsappEnabled: values?.whatsappEnabled,
            fuseauHorraire: values?.fuseauHorraire ? values?.fuseauHorraire : user?.fuseauHorraire,
          })
        );
      } else {
        message.warning({
          content: "une erreur est survenue",
        });
      }
    } catch (error: any) {
      let content = "";
      for (
        let index = 0;
        index < error?.response?.data?.message?.length;
        index++
      ) {
        content = error?.response?.data?.message[index] + ", " + content;
      }
      message.error({
        content: content,
      });
    } finally {
      setIsUpdatingData(false);
      ///sendOTP("+" + values?.phone);
    }
  };

  const [phone, setPhone] = useState<any>(user?.phone);
  const [isTyping, setIsTyping] = useState(false);

  const handlePhoneChange = (value: string, country: any) => {
    setIsTyping(true);
    const countryCode = country.countryCode as keyof typeof fr;
    const countryNameFr = fr[countryCode];
    setPhone(value);
    formInfos.setFieldsValue({ phone: value });
  };

  //!EFFECTS
  useEffect(() => {
    if (user) {
      if (user?.roles.includes("student")) {
        formInfos.setFieldsValue({
          email: user?.email || "",
          phone: user?.phone,
          firstname: user?.firstname || "",
          lastname: user?.lastname || "",
          pays: user?.pays || "",
          educSystem: user?.educSystem[0] || "",
          etablissement: user?.etablissement || "",
          whatsappEnabled: user?.whatsappEnabled,
        });
        setIsPhoneVerified(!!user?.phone || false);
        setIsEmailVerified(user?.emailVerified || false);
      }
      else {
        formInfos.setFieldsValue({
          email: user?.email || "",
          phone: user?.phone,
          pays: user?.pays || "",
          firstname: user?.firstname || "",
          lastname: user?.lastname || "",
          whatsappEnabled: user?.whatsappEnabled,
        });

        form.setFieldsValue({
          career: user?.career || "",
          education: user?.education || "",
          experience: user?.experience || "",
        });
        setIsPhoneVerified(user?.phone || false);
        setIsEmailVerified(user?.emailVerified || false);
      }
    }
  }, [user, formInfos, form]);

  useEffect(() => {
    if (isCorrectingLevel) {
      setCurrentStep("2");
    }
    else {
      setCurrentStep("0");
    }
  }, [isCorrectingLevel]);

  useEffect(() => {
    if (profileDrawerOpen && user) {
      if (user?.roles?.includes("student")) {
        setSelectedAvatar(user?.profile);
      }
    }
  }, [profileDrawerOpen, user]);

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(
    user?.profile
      ? user.profile
      : `https://gravatar.com/avatar/${user?._id}?d=identicon`
  );

  const handleChange = (info: any) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }

    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url: any) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const [width, setwidth] = useState<string>();
  const smallDevices = window.matchMedia("only screen and (max-width: 992px)");
  const mediumDevices = window.matchMedia("only screen and (min-width: 992px)");

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  const s_videoSizeController = (x: any) => {
    if (x.matches) {
      setwidth("100%");
    }
  };

  const m_videoSizeController = (x: any) => {
    if (x.matches) {
      setwidth("78%");
    }
  };

  // !USE_EFFECT
  useEffect(() => {
    s_videoSizeController(smallDevices);
    smallDevices.addListener(s_videoSizeController);
    m_videoSizeController(mediumDevices);
    mediumDevices.addListener(m_videoSizeController);
  }, []);

  const formRef = React.createRef<HTMLFormElement>();

  const handleCustomSubmit = () => {
    if (formRef.current) {
      setIsLoading(true);
      formRef.current.submit();
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    }
  };

  const handleSpnsorCodeCopy = () => {
    if (user?.referralCode) {
      navigator.clipboard
        .writeText(user?.referralCode)
        .then(() => {
          message.success("Code parrainage copié !");
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
        });
    } else {
      console.warn("No referral code to copy!");
    }
  };

  const [passwordDrawerVisible, setPasswordDrawerVisible] = useState(false);
  const onClosePasswordDrawer = () => {
    setPasswordDrawerVisible(false);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    if (newPasswordRequired) {
      setPasswordDrawerVisible(true);
      setIsWelcomeModalVisible(true);
    }
  }, [newPasswordRequired]);

  return (
    <div>
      <Container>
        <Drawer
          headerStyle={{ width: "35vw", position: "relative" }}
          title={false}
          closable={false}
          extra={
            <div style={{ width: 100 }}>
              <Progress percent={30} size="small" status="exception" />
            </div>
          }
          width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "85%" : isMediumScreen ? "80%" : isNormalScreen ? "75%" : "70%"}
          height={"100%"}
          onClose={closeDrawer}
          placement={width === "100%" ? "bottom" : "right"}
          visible={profileDrawerOpen && isLoggedIn}
        >

          <div className={s.back__icon}>
            <Image src={BackBlack} width={25} preview={false} onClick={closeDrawer} style={{ cursor: "pointer" }} />
            {!isMobile && currentStep === "2" && <AppButton loading={isLoading || isUpdatingData} onClick={handleCustomSubmit} style={{ marginLeft: "10px" }}>
              Mettre à jour
            </AppButton>}
          </div>

          <div className={s.headerBox}>
            <div className={s.logoutButton}>
              <Popconfirm
                placement="left"
                title={"Tu confirmes la déconnexion ?"}
                onConfirm={disconnect}
                okText="Oui"
                cancelText="Non"
              >
                <Button style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", border: "1px solid #FA0000", borderRadius: "12px", fontSize: isMobile ? "0.8em" : "14px", fontWeight: "500", color: "#FA0000" }}>
                  Se déconnecter
                  <LogoutOutlined
                    style={{
                      color: "#FA0000",
                      fontSize: "1.5em",
                      marginTop: "1px"
                    }}
                  />
                </Button>
              </Popconfirm>
            </div>
          </div>

          <div className={s.container__profile} >
            <Row justify="center">
              <Col>
                {!user?.roles?.includes("student") && <UploadAvatar
                  path={`${AUTH_TEACHER}/${user?._id}`}
                />}
                {user?.roles?.includes("student") && <div style={{ height: "100px", width: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <img src={selectedAvatar} height={80} style={{ borderRadius: "50%", cursor: "pointer" }} onClick={() => setIsModalVisible(true)}></img>
                  <img src={EditButton} height={70} style={{ position: "absolute", right: "-20px", bottom: "-20px", cursor: "pointer" }} onClick={() => setIsModalVisible(true)}></img>
                </div>}
              </Col>
            </Row>

            <div className={s.pseudo}>
              <h3>
                Bienvenue {/* {t("app.welcome")} */}
                {user?.firstname ? user?.firstname : user?.lastname}
                {user?.roles?.includes("teacher") && user?.certified && <a style={{ position: "relative", bottom: "5px" }}><CertificationBadge /></a>}
              </h3>

              {user?.pseudo && (
                <h4
                  style={{
                    fontFamily: "var(--body-font)",
                    fontSize: "14px",
                    color: "var(--text-color)",
                  }}
                >
                  Mon pseudo : {user?.pseudo}
                </h4>
              )}

              {user?.roles.includes("student") && user?.referralCode && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: isMobile ? "10px" : "20px" }}>
                Mon code parrain : {" "}
                <Button className={s.sponsorButton} onClick={handleSpnsorCodeCopy}>
                  {user?.referralCode}
                  <CopyOutlined style={{ marginLeft: "5px" }} />
                </Button>
              </div>}
            </div>

            {user?.roles.includes("student") && (
              <Fragment>
                <div className={s.info}>
                  <p>Complète ton profil</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: isMobile ? "100%" : "55%",
                    margin: "auto",
                  }}
                >
                  <StudentUpdateProfile
                    isEmailVerified={isEmailVerified}
                    isPhoneVerified={isPhoneVerified}
                    isUpdating={isUpdatingData}
                    formInfos={formInfos}
                    updateUserInfos={updateUserInfos}
                    setOpenPhoneModification={setOpenPhoneModification}
                  />
                </div>
              </Fragment>
            )}

            {user?.roles.includes("parent") && (
              <Fragment>
                <div className={s.info}>
                  <p>Mon profil</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: isMobile ? "100%" : "55%",
                    margin: "auto",
                  }}
                >
                  <ParentOrganismUpdateProfile
                    isEmailVerified={isEmailVerified}
                    isPhoneVerified={isPhoneVerified}
                    isUpdating={isUpdatingData}
                    formInfos={formInfos}
                    updateUserInfos={updateUserInfos}
                    setOpenPhoneModification={setOpenPhoneModification}
                  />
                </div>
              </Fragment>
            )}

            {user?.roles.includes("organisme") && (
              <Fragment>
                <div className={s.info}>
                  <p>Mon profil</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: isMobile ? "100%" : "55%",
                    margin: "auto",
                  }}
                >
                  <ParentOrganismUpdateProfile
                    isEmailVerified={isEmailVerified}
                    isPhoneVerified={isPhoneVerified}
                    isUpdating={isUpdatingData}
                    formInfos={formInfos}
                    updateUserInfos={updateUserInfos}
                    setOpenPhoneModification={setOpenPhoneModification}
                  />
                </div>
              </Fragment>
            )}

            {user?.roles.includes("teacher") && (
              <div
                style={{
                  width: "100%",
                  maxWidth: `${currentStep == "1" && !isMobile ? "55%" : "100%"}`,
                  margin: "auto",
                }}
              >
                <Tabs
                  activeKey={currentStep}
                  centered
                  type="line"
                  onChange={(activeKey: string) => setCurrentStep(activeKey)}
                >
                  <TabPane tab={<div className={currentStep == "0" ? s.tabTitleBoxActive : s.tabTitleBox}>Mon profil</div>} key="0">
                    <ProfileTeacher
                      displayBreadcrumbs={false}
                      displayButtonProfile={profileDrawerOpen}
                    />
                  </TabPane>
                  <TabPane tab={<div className={currentStep == "1" ? s.tabTitleBoxActive : s.tabTitleBox}>Informations personnelles</div>} key="1">
                    <Form form={formInfos} onFinish={updateUserInfos}>
                      <Form.Item
                        hasFeedback
                        validateStatus={isEmailVerified ? "success" : "warning"}
                        // help={isEmailVerified ? "Email validé" : "Email non validé"}
                        label={null}
                        name="email"
                        rules={[
                          { required: true, message: "Champ obligatoire" },
                        ]}
                        style={{ margin: 0, padding: 0 }}
                      >
                        <Input
                          size="large"
                          className={s.field}
                          placeholder={t("auth.email")}
                          readOnly={true}
                        />
                      </Form.Item>

                      <Form.Item
                        hasFeedback
                        validateStatus={isPhoneVerified ? "success" : "warning"}
                        help={isPhoneVerified || isTyping ? null : t("auth.phoneNotVerified")}
                        label={null}
                        name="phone"
                        rules={[{ required: false, message: "Champ obligatoire" }]}
                        style={{
                          margin: 0,
                          padding: 0,
                          marginBottom: "15px",
                        }}
                      >
                        <PhoneInput
                          country="fr"
                          disableCountryCode={false}
                          disableDropdown={false}
                          enableSearch
                          specialLabel=""
                          value={phone}
                          onChange={handlePhoneChange}
                          onClick={() => setOpenPhoneModification(true)}
                          inputProps={{
                            name: "phone",
                            required: true,
                            readOnly: true,
                            autoFocus: true,
                            className: `ant-input ant-input-lg ${s.field}`,
                            style: {
                              paddingLeft: "50px",
                            },
                          }}
                          localization={fr}
                        />
                        {isPhoneVerified ? (
                          <img
                            src={CheckIcon}
                            height={13}
                            style={{ color: "green", position: "absolute", right: 10, top: 12 }}
                          />
                        ) : (
                          <ExclamationCircleOutlined
                            style={{ color: "#faad14", position: "absolute", right: 10, top: 12 }}
                          />
                        )}
                      </Form.Item>

                      <Form.Item
                        hasFeedback
                        validateStatus={
                          !!user?.firstname ? "success" : "warning"
                        }
                        help={!!user?.firstname ? "" : "Prénom non validé"}
                        label={null}
                        name="firstname"
                        rules={[
                          { required: true, message: "Champ obligatoire" },
                        ]}
                        style={{ margin: 0, padding: 0 }}
                      >
                        <Input
                          className={s.field}
                          size="large"
                          placeholder={t("auth.firstname")}
                        />
                      </Form.Item>

                      <Form.Item
                        hasFeedback
                        validateStatus={
                          !!user?.lastname ? "success" : "warning"
                        }
                        help={!!user?.lastname ? "" : "Nom non validé"}
                        name="lastname"
                        rules={[
                          { required: true, message: "Champ obligatoire" },
                        ]}
                        style={{ margin: 0, padding: 0 }}
                      >
                        <Input
                          size="large"
                          className={s.field}
                          bordered={false}
                          placeholder={t("auth.lastname")}
                        />
                      </Form.Item>

                      <TimeZoneList formInfos={user?.fuseauHorraire} />

                      <div className={s.termes__legals}>
                        <Form.Item
                          name="whatsappEnabled"
                          valuePropName="checked"
                          style={{ marginBottom: "20px" }}
                        >
                          <Checkbox
                            style={{ color: "#636363" }}
                            className={s.policy}
                            onChange={(e) => formInfos.setFieldsValue({ whatsappEnabled: e.target.checked })}
                          >
                            {" "}
                            Autoriser les notifications whatsapp
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <Form.Item style={{ margin: 0, padding: 0 }}>
                        <Row gutter={20} justify="center">
                          <div
                            style={{
                              width: "50%",
                              marginLeft: "auto",
                              marginRight: "auto",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Button
                              htmlType="submit"
                              block
                              type="primary"
                              size="middle"
                              loading={isUpdating || isUpdatingData}
                              className={s.button}
                            >
                              Mettre à jour
                            </Button>
                          </div>
                        </Row>
                      </Form.Item>
                    </Form>
                    <div style={{ margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Button className={s.passwordButton} onClick={() => setPasswordDrawerVisible(true)}>Modifier le mot de passe</Button>
                    </div>
                    <div style={{ margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Popconfirm
                        placement="top"
                        title={"Es-tu sur de vouloir supprimer ton compte ?"}
                        onConfirm={deleteAccount}
                        okText="Oui"
                        cancelText="Non"
                      >
                        <Button className={s.deleteButton} loading={loading}>
                          Supprimer mon compte
                        </Button>
                      </Popconfirm>
                    </div>
                  </TabPane>

                  <TabPane tab={<div className={currentStep == "2" ? s.tabTitleBoxActive : s.tabTitleBox}>Niveaux et à propos</div>} key="2">
                    <UpdateProfileStepTwo formRef={formRef} />
                  </TabPane>
                </Tabs>
              </div>
            )}
          </div>
          {!user?.roles?.includes("teacher") && <div style={{ margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Button className={s.passwordButton} onClick={() => setPasswordDrawerVisible(true)}>Modifier le mot de passe</Button>
          </div>}
          {!user?.roles?.includes("teacher") && <div style={{ margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Popconfirm
              placement="top"
              title={"Es-tu sur de vouloir supprimer ton compte ?"}
              onConfirm={deleteAccount}
              okText="Oui"
              cancelText="Non"
            >
              <Button className={s.deleteButton} loading={loading}>
                Supprimer mon compte
              </Button>
            </Popconfirm>
          </div>}
          <UpdatePasswordDrawer visible={passwordDrawerVisible} onClose={onClosePasswordDrawer} />
          <AvatarModal
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            onSelect={(avatar) => {
              setSelectedAvatar(avatar);
              setIsModalVisible(false);
            }}
          />
          <PhoneOTPModal
            visible={openPhoneVerification}
            phone={userPhoneNumber}
            onCancel={() => setOpenPhoneVerification(false)}
            onVerify={handleVerify}
            onResend={() => sendOtp(userPhoneNumber)}
            isLoading={loading}
          />
          <PhoneModificationModal
            visible={openPhoneModification}
            onCancel={() => setOpenPhoneModification(false)}
          />
          <div id="recaptcha-container"></div>
        </Drawer>
        <WelcomeModal
          visible={isWelcomeModalVisible}
          onClose={() => setIsWelcomeModalVisible(false)}
        />

        <WhatsappAlertModal
          visible={isWhatsappModalVisible}
          onClose={closeWhatsappDrawer}
          onStay={() => setIsWhatsappModalVisible(false)}
        />
      </Container>
    </div>
  );
};
